import { all, fork } from 'redux-saga/effects';

// Import page sagas
import { watchLoginActions } from '../../pages/Login/saga';
import { watchAccountsActions } from '../../pages/Users/Accounts/saga';
import { watchRolesActions } from '../../pages/Users/Roles/saga';
import { watchApprovalAccountsActions } from '../../pages/Users/ApprovalAccounts/saga';
import { watchAccountManagementActions } from '../../pages/Users/AccountManagement/saga';
import { watchUnitsActions } from '../../pages/Catalog/Units/saga';
import { watchVehiclesActions } from '../../pages/Catalog/Vehicles/saga';
import { watchVehicleTypesActions } from '../../pages/Catalog/VehicleTypes/saga';
import { watchEntryExitReasonsActions } from '../../pages/Catalog/EntryExitReasons/saga';
import { watchLicensesActions } from '../../pages/LicenseManagement/Licenses/saga';
import firmwareVersionsSaga from '../../pages/LicenseManagement/FirmwareVersions/saga';
import { watchDevicesActions } from '../../pages/DeviceManagement/Devices/saga';
import { watchDeviceConfigActions } from '../../pages/DeviceManagement/DeviceConfiguration/saga';
import { watchPositionsActions } from '../../pages/Catalog/Positions/saga';
import { watchOfficerGroupsActions } from '../../pages/Catalog/OfficerGroups/saga';
import { watchVisitTypesActions } from '../../pages/Catalog/VisitTypes/saga';
import { watchVisitTypeCategoriesActions } from '../../pages/Catalog/VisitTypeCategories/saga';
import { watchEntryExitStatusesActions } from '../../pages/Catalog/EntryExitStatuses/saga';
import identityTypesSaga from '../../pages/Catalog/IdentityTypes/saga';
import { watchVerifyModesActions } from '../../pages/Catalog/VerifyModes/saga';
import { watchAccessReportActions } from '../../pages/Reports/AccessReport/saga';
import { watchDeviceReportActions } from '../../pages/Reports/DeviceReport/saga';
import { watchDatabaseAnalysisActions } from '../../pages/Reports/DatabaseAnalysis/saga';
import { watchViolationReportActions } from '../../pages/Reports/ViolationStatistics/saga';
import { watchSettingsActions } from '../../pages/System/Settings/saga';
import { watchSystemLogsActions } from '../../pages/System/SystemLogs/saga';
import { watchAlertConfigurationsActions } from '../../pages/System/AlertConfigurations/saga';
import vneidStatisticsSaga from '../../pages/Statistics/VNeIDStatistics/saga';
import { watchVerificationQueriesActions } from '../../pages/Statistics/VNeIDVerificationQueries/saga';
import { watchVneidSdkActions } from '../../pages/Statistics/VNeIDStatistics/sagaTab4';
import { watchQueryMonitoringActions } from '../../pages/Statistics/VNeIDStatistics/sagaTab5';
import { watchBackupLogsActions } from '../../pages/Reports/BackupLogs/saga';
import { watchLGSPIntegrationActions } from '../../pages/Reports/LGSPIntegration/saga';
import { watchDashboardActions } from '../../pages/Dashboard/saga';
import { watchSyncDataActions } from '../../pages/Backup/SyncData/saga';
import { watchSystemBackupActions } from '../../pages/Backup/SystemBackup/saga';
import { watchUnitsBackupActions } from '../../pages/Backup/UnitsBackup/saga';
import { watchBtl86BackupActions } from '../../pages/Backup/BTL86Backup/saga';
import { watchNotificationActions } from '../../components/NotificationIcon/saga';
import { watchLicenseUnitsActions } from '../../pages/LicenseManagement/LicenseUnits/saga';

/**
 * Root saga
 * Combines all sagas and runs them
 */
export default function* rootSaga() {
  yield all([
    fork(watchLoginActions),
    fork(watchAccountsActions),
    fork(watchRolesActions),
    fork(watchApprovalAccountsActions),
    fork(watchAccountManagementActions),
    fork(watchUnitsActions),
    fork(watchVehiclesActions),
    fork(watchVehicleTypesActions),
    fork(watchEntryExitReasonsActions),
    fork(watchLicensesActions),
    fork(firmwareVersionsSaga),
    fork(watchDevicesActions),
    fork(watchDeviceConfigActions),
    fork(watchPositionsActions),
    fork(watchOfficerGroupsActions),
    fork(watchVisitTypeCategoriesActions),
    fork(watchEntryExitStatusesActions),
    fork(identityTypesSaga),
    fork(watchVerifyModesActions),
    fork(watchVisitTypesActions),
    fork(watchAccessReportActions),
    fork(watchDeviceReportActions),
    fork(watchDatabaseAnalysisActions),
    fork(watchViolationReportActions),
    fork(watchSettingsActions),
    fork(watchSystemLogsActions),
    fork(watchVerificationQueriesActions),
    fork(vneidStatisticsSaga),
    fork(watchVneidSdkActions),
    fork(watchQueryMonitoringActions),
    fork(watchBackupLogsActions),
    fork(watchLGSPIntegrationActions),
    fork(watchDashboardActions),
    fork(watchSyncDataActions),
    fork(watchSystemBackupActions),
    fork(watchUnitsBackupActions),
    fork(watchBtl86BackupActions),
    fork(watchNotificationActions),
    fork(watchAlertConfigurationsActions),
    fork(watchLicenseUnitsActions),
  ]);
}
